import React from "react";
import paragraphs from "./copyright-statement-en.json";

export default function EnglishCopyrightStatement() {
    const [title, ...body] = paragraphs;

    return (
        <div className="mypageContents aboutContents">
            <div className="mypageContents__inner2">
                <header className="mainHeading">
                    <h1 className="mainHeading__title">{title}</h1>
                </header>
                <div className="aboutBox">
                    <div className="aboutBox__inner" style={{ paddingBottom: "60px" }}>
                        {body.map((text, index) =>
                            text === "Translator's Notes" ? (
                                <h3 className="termsof__item__title" key={index}>
                                    {text}
                                </h3>
                            ) : (
                                <p key={index}>{text}</p>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
